export enum WebhookEventType {
  UNSET_EVENT_TYPE = 'UNSET_EVENT_TYPE', // Do not use, needed because of proto3 limitations
  END_USER_CREATED = 'END_USER_CREATED',
  END_USER_INFO_UPDATED = 'END_USER_INFO_UPDATED',
}
